import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ContentTypeFilterClause,ExplorableItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { ServerUserContentType } from '~src/ts/models/ContentTypes';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';
import { ServerUsers } from '~src/userManagement/services/resources/ServerUsers';

import { getNoDefaultFilters } from './getDefaultFilters';

export const ServerUserDefinition: SpaceDefinition<'serveruser'> & ExplorableItemDefinition = {
  itemType: 'serveruser',
  contentType: 'serveruser',
  singularName: Messages.serverUser,
  pluralName: Messages.serverUsers,
  emptyStateMessage: Messages.usersEmptyMessage,
  contentFilterKeys: ServerUserContentType.filterKeys,
  filterClause: ServerFilterClauses.ContentType(['serveruser']) as ContentTypeFilterClause,
  defaultFilters: getNoDefaultFilters,
  supportedDisplayModes: ['list'],
  cardComponent: GenericCard,
  listViewIconUrl: null,
  contentSpaceUrl: (urls, id) => '', // note this is used for breadcrumbs/clicking on card and list view, //might have to be refactored to take in the entire item
  headerIconPath: (contentInfo: ISpaceItemDetailInfo<'serveruser'>) => {
    if (contentInfo.userImageUrl) {
      return contentInfo.userImageUrl;
    }
    return imgPath('user_content_type.svg');
  },
  getContentInfo: () => {
  },
  getBasicQuery: () => {
    return ServerUsers.instance.all();
  },
};
